import { useState, useEffect, useRef, Fragment, memo, useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./PotDetail.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import AppConfig from '../../AppConfig';
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import * as YStyled from "../../Styleds";
import EventItem from "./../../pages/Tab0/EventItem";
import { CustomEventManager } from "../../comm/global/CustomEventManager";
import apiManager from '../../ApiManager';
import { GameContext } from "../../GameContext";
const customEventManager = new CustomEventManager()
const PotDetail = ({ setModalType, arg, addModalType }) => {
    const { preProcessEvent, userData, updatePocketlist } = useContext(GameContext);
    const [inProp, setInProp] = useState(false);
    const containerRef = useRef(null);
    const [itemWidth, setItemWidth] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [rewildEvents, set_rewildEvents] = useState([]);
    useEffect(() => {
        apiManager.fetchGet(`event`, { event_rewilding: arg.pot.rewilding_id }, 0).then(res => {
            console.log("res", res)
            const processEvents = async () => {
                const __events = await Promise.all(res.map(async (event) => {
                    return await preProcessEvent(event);
                }));
                set_rewildEvents(__events);
            };
            processEvents();
        })
        setInProp(true);
    }, [])
    useEffect(() => {
        if (containerRef.current) {
            const firstItem = containerRef.current.firstChild;
            if (firstItem) {
                setItemWidth(firstItem.getBoundingClientRect().width);
            }
        }
    }, [containerRef]);
    const handleScroll = (event) => {
        const scrollLeft = event.target.scrollLeft;
        const newIndex = Math.round(scrollLeft / itemWidth);
        setCurrentIndex(newIndex);
    };
    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "PotDetail"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.photos}>
                                    <div className={styleUi.photoSwipe} onScroll={handleScroll} ref={containerRef}>
                                        {arg.pot.rewilding_photos.map((v, k) => (
                                            <img src={v.rewilding_photos_path} key={k} />
                                        ))}

                                    </div>
                                    <div className={styleUi.dots}>
                                        {arg.pot.rewilding_photos.map((v, k) => (
                                            <div key={k} className={k === currentIndex ? ` ${styleUi.selected}` : styleUi.dot} >
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className={styleUi.content}>
                                    <YStyled.Span size={28} fontWeight={600} style={{ paddingLeft: "1rem" }}>{arg.pot.rewilding_name}</YStyled.Span>
                                    <YStyled.Span size={15} fontWeight={400} color="#00000070" style={{ paddingLeft: "1rem", paddingTop: ".5rem" }}>{arg.pot.rewilding_location.join("．")}</YStyled.Span>
                                    <YStyled.Span size={17} style={{ paddingLeft: "1rem", paddingTop: "1.5rem" }}>參考資訊</YStyled.Span>
                                    <div className={styleUi.links}>
                                        {arg.pot.rewilding_reference_links &&
                                            <>
                                                {arg.pot.rewilding_reference_links.map((linkObj, k) => {
                                                    return <div className={styleUi.link} onClick={e => {
                                                        window.open("https://hiking.biji.co/", "_blank");
                                                    }}>
                                                        <img src="./assets/ui/link.png" />
                                                        <span>健行筆記</span>
                                                        <img src="./assets/ui/upArrow.png" />
                                                    </div>
                                                })}
                                            </>
                                        }
                                    </div>
                                    {
                                        arg.type === "tab0" &&
                                        <>
                                            <YStyled.Span size={17} style={{ padding: "1rem" }}>最新活動</YStyled.Span>
                                            <div className={styleUi.events}>
                                                {rewildEvents.map((v, k) => {
                                                    return <div>
                                                        <EventItem vo={v} addModalType={addModalType} />
                                                    </div>
                                                })}
                                            </div>
                                        </>
                                    }
                                </div>
                                {arg.type === "tab0" &&
                                    <div className={styleUi.bottom}>
                                        <button className={allStyle.btnGray1} onClick={() => {
                                            const locationName = encodeURIComponent(arg.pot.location_name); // 確保名稱是 URL 安全的
                                            const url = `https://www.google.com/maps/place/?q=place_id:${arg.pot.rewilding_place_id}`;
                                            window.open(url, "_blank");
                                        }}>
                                            規劃路線
                                        </button>

                                        <button className={allStyle.btnGray1} onClick={e => {
                                            setInProp(false);
                                            if (userData)
                                                addModalType({
                                                    cls: "NewEvent", arg: {
                                                        pot: arg.pot,
                                                        cb: () => {

                                                        }
                                                    }
                                                })
                                            else
                                                window.location.href = AppConfig.registerUrl();
                                        }}>
                                            開始揪團
                                        </button>
                                    </div>
                                }
                                {arg.type === "selPot" &&
                                    <div className={styleUi.bottomAdd} onClick={e => {
                                        customEventManager.dispatch("selPot", arg.pot);
                                    }}>
                                        <span>
                                            加入行程
                                        </span>
                                    </div>
                                }
                                <IconButton className={styleUi.back} onClick={e => {
                                    setInProp(false)
                                }}>
                                    <img src="./assets/ui/back.png" />
                                </IconButton>
                                <IconButton className={styleUi.save} onClick={e => {
                                    if (userData)
                                        addModalType({
                                            cls: "SavePot", arg: {
                                                cb: (pocketListObj) => {
                                                    apiManager.fetchPost(`pocket-list/${pocketListObj.pocket_lists_id}/items`, {
                                                        pocket_list_items_place_id: arg.pot.rewilding_place_id,
                                                        pocket_list_items_place_name: arg.pot.rewilding_name,
                                                    }).then(res => {
                                                        console.log(res);
                                                        updatePocketlist("updateList", pocketListObj.pocket_lists_id);
                                                    })
                                                }
                                            }
                                        })
                                    else
                                        window.location.href = AppConfig.registerUrl();
                                }}>
                                    <img src="./assets/ui/save.png" />
                                </IconButton>
                                <IconButton className={styleUi.share} onClick={async (e) => {
                                    const currentDomain = window.location.origin; // 获取当前的域名和协议，例如 "http://localhost:3000"
                                    const invitePath = `?type=rewildInfo&id=${arg.pot.rewilding_id}`; // 你想要生成的路径
                                    const inviteLink = `${currentDomain}${invitePath}`; // 构造完整的邀请链接
                                    if (navigator.share) {
                                        try {
                                            await navigator.share({
                                                title: arg.pot.rewilding_name,
                                                text: 'OOSA',
                                                url: inviteLink // 你想要分享的网址
                                            });
                                            console.log('分享成功');
                                        } catch (error) {
                                            console.log('分享失败', error);
                                        }
                                    } else {
                                        navigator.clipboard.writeText(inviteLink).then(() => {
                                            alert('己複製連結');
                                        }).catch(err => {
                                            console.error("複製到剪貼簿失敗：", err);
                                        });
                                    }
                                }}>
                                    <img src="./assets/ui/Share.png" />
                                </IconButton>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(PotDetail);